import {Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {CookieService} from 'ngx-cookie-service';
import {NavigationEnd, Router} from '@angular/router';
import {StorelistDialogComponent} from '~/app/web/components/storelist-dialog/storelist-dialog.component';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';
import {ConfirmationService} from '~/app/core/common/services/confirmation.service';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {MenuService} from 'mclane-apptemplate-lib';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {environment} from '~/environments/environment';
import {JwtService, OauthService} from 'mclane-webauth-lib';
import {Subscription} from 'rxjs';
import {CommonService} from "./shared/services/common.service";
import { gearIcon, userIcon, logoutIcon, bellIcon, undoIcon, homeIcon } from '@progress/kendo-svg-icons';


declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    env = environment;
    title = 'application';
    public opened = false;
    tempRef: any;
    @ViewChild('user', {read: ElementRef})
    public userTemplate: TemplateRef<any>;
    public storeChangable;
    events: string[] = [];
    openedSide: boolean;
    pageTitle: any;
    private menuSubscription: Subscription;
    menutype: any[];


    constructor(
        public _storeListService: StoreListService,
        public dialogHelper: DialogHelperComponent,
        private cookieService: CookieService,
        private router: Router,
        private _profileCategoriesService: ProfileCategoriesService,
        private _confirmationService: ConfirmationService,
        public applicationSettingsHelper: ApplicationSettingsHelper,
        public errorApiService: ErrorApiService,
        private _jwtService: JwtService,
        public loadingIndicatorHelper: LoadingIndicatorHelper,
        public confirmationService: ConfirmationService,
        public menuservice: MenuService,
        public config: ConfigurationService,
        public oauthService: OauthService,
        private commonService: CommonService) {

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                gtag('config', 'UA-157449057-1',
                    {
                        'page_path': event.urlAfterRedirects
                    }
                );
            }
        });
    }

    async ngOnInit() {
        if (this._jwtService.roles === undefined) {
            this.router.navigate(['/access_denied']).then(() => {
            });
          
        } else {
            this.buildMenu();
            this.config.BASEURL = window.location.protocol + '//' + window.location.host;
            this.config.BASEURL_OLI = window.location.protocol + '//' + window.location.host;
        }

        this.menuSubscription = this.menuservice.eventRan.subscribe((event:any) => {
            if (event.text === 'Help') {
                window.open('https://www.mclaneco.com/sl', '_blank', 'noopener');
            }
        });
    }

    buildMenu() {
        const userName=this._jwtService.preferred_username;
        const showMog = this._jwtService.roles == undefined && !this._jwtService.roles.includes('Above_Store');
        const notifications = {
            text: '',
            separator: false,
            icon: bellIcon,
            disabled: this.confirmationService.confirmationItemList.length < 1,
            url: '',
            subItems: null,
            class: 'iconOnly',
        };
      this.menutype=[
        // notifications,
        {
            text: 'Home',
            separator: false,
            icon: homeIcon,
            disabled: false,
            textColor: 'white',
            url: 'home',
            subItems: null
        },
        {text: 'Profile', prepend: '', separator: false, icon: '', disabled: false, url: 'profile', subItems: null},
        {
            text: 'Store List',
            prepend: '',
            separator: false,
            icon: '',
            disabled: false,
            url: 'storelist',
            subItems: null
        },
      
        {
            text: 'Reports', prepend: '', separator: false, icon: '', disabled: false, url: '', subItems:
                [
                    {
                        text: 'New Item',
                        prepend: '',
                        separator: false,
                        icon: '',
                        disabled: false,
                        url: 'reports/newitem',
                        subItems: null
                    },
                    {
                        text: 'OrderGuide-Worksheet',
                        prepend: '',
                        separator: false,
                        icon: '',
                        disabled: false,
                        url: 'reports/orderguide-worksheet',
                        subItems: null
                    },

                ]
        },
        {
            text: 'Invoices',
            separator: false,
            icon: '',
            disabled: false,
            textColor: 'white',
            url: '',
            subItems: null
        },
        {text: 'Help', 
        prepend: '', 
        separator: false, 
        icon: '', disabled: 
        false, url: '', 
        subItems: null}

    ];

    if(this.commonService.hasAccess(['Above_Store'])) {
        this.menutype.push( {
            text: 'MOG',
            prepend: '',
            separator: false,
            disabled: false,
            icon: '',
            url: 'mog',
            subItems: null
        });
    }
   this.menuservice.setItems(this.menutype,userName,true);
}

    test400() {
        this.loadingIndicatorHelper.show('');
        this.errorApiService.test400().then(() => {
        });
    }

    test401() {
        this.loadingIndicatorHelper.show('');
        this.errorApiService.test401().then(() => {
        });
    }

    test403() {
        this.loadingIndicatorHelper.show('');
        this.errorApiService.test403().then(() => {
        });
    }

    test404() {
        this.loadingIndicatorHelper.show('');
        this.errorApiService.test404().then(() => {
        });
    }

    test500() {
        this.loadingIndicatorHelper.show('');
        this.errorApiService.test500().then(() => {
        });
    }

    throwSplunkErrorAPI() {
        this.errorApiService.testSplunk().then(() => {
        });
    }

    changeSelectedStore(dialog: StorelistDialogComponent) {
        if (!this.storeChangable) {
            return;
        }
        this.dialogHelper.showStoreDialog(this.tempRef, dialog, this._storeListService.storeList).then(r => r);
    }

    public close() {
        this.opened = false;
    }

    public open() {
        this.opened = true;
    }

    onActivate($event: any) {
        this.tempRef = $event;
        this.storeChangable = $event.storeChangable;
    }

    ngOnDestroy(): void {
        this.menuSubscription.unsubscribe();
    }
}

